import { XeroAccount } from './xero-account.model';
import { handleActions } from 'redux-actions';
import {
  ActionsEnum,
  UpdateXeroAccount,
  UpdateXeroAccountNetworkError,
  UpdateXeroAccountNetworkSuccess,
} from './xero-data.actions';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const FEATURE_NAME = 'xero-data';

export interface IState {
  xeroAccount: XeroAccount;
  updateError: Error;
}

// initial state
export const initialState: IState = {
  xeroAccount: null,
  updateError: null,
};

const reducerFn = handleActions(
  {
    [ActionsEnum.UPDATE_XERO_ACCOUNT]: function (
      state: IState,
      { payload }: UpdateXeroAccount
    ): IState {
      const { xeroAccount } = payload;

      return {
        ...state,
        xeroAccount,
      };
    },
    [ActionsEnum.UPDATE_XERO_ACCOUNT_NETWORK_ERROR]: function (
      state: IState,
      { payload }: UpdateXeroAccountNetworkError
    ): IState {
      const { error } = payload;

      return {
        ...state,
        updateError: error,
      };
    },
    [ActionsEnum.UPDATE_XERO_ACCOUNT_NETWORK_SUCCESS]: function (
      state: IState,
      { payload }: UpdateXeroAccountNetworkSuccess
    ): IState {
      return {
        ...state,
        updateError: null,
      };
    },
    [ActionsEnum.RESET_UPDATE_XERO_ERROR]: function (state: IState): IState {
      return {
        ...state,
        updateError: null,
      };
    },
  } as any,
  initialState
);

export function reducer(state: IState = initialState, action: any) {
  return reducerFn(state, action);
}

const selectFeature = createFeatureSelector<IState>(FEATURE_NAME);

export const getXeroAccount = createSelector(
  selectFeature,
  (state: IState) => state.xeroAccount
);
export const getUpdateError = createSelector(
  selectFeature,
  (state: IState) => state.updateError
);
